module.exports = __webpack_public_path__ + "img/ic_24_play_white.bffdf92d.svg";